import AbstractField from '@/app/modules/shared/components/forms/inputs/abstract-field/abstract-field';
import { Component, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import { BRow } from 'bootstrap-vue';

@Component({
  name: 'bpc-separator',
  components: {
    'bpc-row': BRow,
  },
})
export default class Separator extends mixins(AbstractField) {}
